<app-header></app-header>
<div id="page-container">
<div id="content-wrap">
<router-outlet></router-outlet>
</div>
<app-footer></app-footer>
</div>